export const SEND_CODE_FOR_LOGIN = 'SEND_CODE_FOR_LOGIN' as const
export const SEND_CODE_FOR_LOGIN_SUCCEEDED = 'SEND_CODE_FOR_LOGIN_SUCCEEDED' as const
export const RE_SEND_CODE_FOR_LOGIN = 'RE_SEND_CODE_FOR_LOGIN' as const
export const RE_SEND_CODE_FOR_LOGIN_SUCCEEDED = 'RE_SEND_CODE_FOR_LOGIN_SUCCEEDED' as const
export const CALL_CODE_FOR_LOGIN = 'CALL_CODE_FOR_LOGIN' as const
export const LOGIN = 'LOGIN' as const
export const LOGIN_WITH_PASSWORD = 'LOGIN_WITH_PASSWORD' as const
